import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

// Raw building blocks per (model, track type) — the frontend sums these for the
// overall or a per-track-type view and computes ROI itself (returns are on an SP,
// unit-flat-stake basis, so ROI = (return - races) / races).
export interface ModelPerformanceRow {
  ai_model: string;
  ai_version: string;
  track_type: string;
  top_1_races: number | string;
  /** ROI stake: settled picks (excludes winners still waiting for an SP). */
  top_1_staked: number | string;
  top_1_winners: number | string;
  top_1_return: number | string;
  value_races: number | string;
  value_staked: number | string;
  value_winners: number | string;
  value_return: number | string;
  all_picks_winners: number | string;
}

interface ModelPerformanceResponse {
  date: string;
  models: ModelPerformanceRow[];
}

export function useModelPerformance(date: string) {
  return useQuery({
    queryKey: ['model-performance', date],
    queryFn: () => apiClient<ModelPerformanceResponse>(`/meetings/model-performance?date=${date}`),
    enabled: !!date,
  });
}
